import { navigate } from "gatsby";
import getCountry from '@/utils/getCountry.js'

const useNavigate =async (link,out)=>{
    let region =await getCountry()
    // 添加state为了给埋点提供前向地址路径，gatsby的Link和navigate都只能通过添加state才能提供前向地址
    let navState = {state: { from: window.location.pathname}}
   
    if(region=='base'){
        out?window.open(link):navigate(link, navState)
    }else if(!!region){
        out?window.open(`/${region}${link}`): navigate(`/${region}${link}`, navState)
    }
        
    
   
}

export default useNavigate